module.exports = __webpack_public_path__ + "img/rnv-logo-small.ffbfa30d.svg";